import React, { Component } from 'react'
import { connect } from 'react-redux'

import Documento from './Documento/'
import Contrato from './Contrato/'

import {
    getDocumento,
} from '../../actions/documentos'
import { getParameterByName } from '../../actions/common';



class TipoDocumento extends Component {

    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.getDocumento(this.props.match.params.id)
        }
        this.props.getParameterByName('ALMACEN')
    }

	render() {

        const { documento } = this.props

        switch (documento.get('tipo')) {
            case 5: return <Contrato documento={documento} />
            default: return <Documento documento={documento}/>
        }
	
	}
}

function mapStateToProps(state) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getDocumento: (id) => dispatch(getDocumento(id)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TipoDocumento)


// WEBPACK FOOTER //
// ./src/components/BusquedaDocumento/Documento.jsx